import getFirebase from "../../../api/firebase";
import type { Media } from "./types";

export const fetchMedia = async (userId: string): Promise<Media[]> => {
  const firebase = await getFirebase();

  const results = await firebase
    .firestore()
    .collection("media")
    .where("userId", "==", userId)
    .get();

  return results.docs.map((doc) => doc.data() as Media);
};

export const fetchMediaByProduct = async (productId: string, userId?: string): Promise<Media[]> => {
  const firebase = await getFirebase();

  let query = firebase.firestore().collection("media").where("productId", "==", productId);

  // Add userId filter for non-admin users (required by Firestore security rules)
  if (userId) {
    query = query.where("userId", "==", userId);
  }

  const results = await query.orderBy("time", "desc").get();

  return results.docs.map((doc) => doc.data() as Media);
};
